import { useMemo } from "react";

import { useFeature } from "flagged";

import components from "containers/Form/SimplifiedBuilder/Components";

export const useSFBComponents = () => {
	const isMonumentFeature = useFeature("monument");

	return useMemo(() => {
		const Components = { ...components };
		if (!isMonumentFeature) {
			delete Components.cayuseCOIComponent;
			delete Components.cayuseHumanEthicsStudySearch;
		}

		return Components;
	}, [ isMonumentFeature ]);
};
